<script>
import ViewportWidth from '@/mixins/ViewportWidth';
import { mapGetters } from 'vuex';
import saveDataInLocalStorage from '@/utils/saveDataInLocalStorage';
import { selectionsTransformation } from '../helpers';
import VStyle from '@/utils/VStyle.js';

export default {
  name: 'RangeSlider',
  components: {
    VStyle,
  },
  mixins: [ViewportWidth],
  props: {
    sliderValue: {
      type: Number,
      default: 30,
    },
    sliderLabel: {
      type: String,
      default: '',
    },
    sliderKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tooltipWidth: 28,
      currentValue: -1,
      initValue: 0,
      tooltipTimer: null,
    };
  },
  computed: {
    ...mapGetters({
      sliders: 'Predictor/getSliders',
      selections: 'Predictor/getSelections',
    }),

    isMobile() {
      return this.viewportWidth < 929;
    },
    sliderId() {
      return `predictor-range-slider-${this.sliderKey}`;
    },
    rangeTrackStyle() {
      const { sliderId, sliderValue } = this;
      const offset = ((50 - sliderValue) / 10) * 2 - 18;
      return `#${sliderId}::-moz-range-track{background-size:${sliderValue}% 100%}
              #${sliderId}::-ms-track{background-size:${sliderValue}% 100%}
              #${sliderId}::-webkit-slider-runnable-track{background-size:${sliderValue}% 100%}
              #${sliderId}-value{left:${sliderValue}%;margin-left:${offset}px`;
    },
  },
  watch: {
    currentValue(val) {
      const { sliderLabel: sliderKey, updatePredictor } = this;
      const newValue = parseInt(val);
      updatePredictor({ sliderKey, newValue });
    },
    sliderValue() {
      this.setCurrentValue();
    },
  },
  mounted() {
    this.setCurrentValue();
  },
  unmount() {
    this.cancelTimers();
  },
  methods: {
    setCurrentValue() {
      this.currentValue = this.sliderValue;
    },
    updatePredictor({ sliderKey, newValue }) {
      const { sliders, $store, selections } = this;
      const { commit } = $store;
      const updatedSlidersData = sliders.map(slider => {
        if (slider.label === sliderKey) {
          slider.defaultValue = newValue;
        }
        return slider;
      });
      commit('Predictor/SET_SLIDERS', { sliders: updatedSlidersData });
      saveDataInLocalStorage({ itemName: 'predictor-sliders', data: updatedSlidersData });
      const updatedSelections = selectionsTransformation({
        selections: selections,
        sliders: updatedSlidersData,
      });
      commit('Predictor/SET_SELECTIONS', { selections: updatedSelections });
    },
    deSelectPreset() {
      this.$store.commit('Predictor/SET_SELECTED_PRESET_ID', { id: null });
      saveDataInLocalStorage({ itemName: 'selected-preset-id', data: null });
    },
    cancelTimers() {
      const { tooltipTimer } = this;
      if (tooltipTimer !== null) {
        window.clearTimeout(tooltipTimer);
        this.tooltipTimer = null;
      }
    },
    hideTooltip() {
      const { cancelTimers, sliderId } = this;
      cancelTimers();
      this.tooltipTimer = window.setTimeout(() => {
        document.getElementById(`${sliderId}-value`).style.opacity = '0';
      }, 200);
    },
    showTooltip() {
      const { cancelTimers, sliderId } = this;
      cancelTimers();
      document.getElementById(`${sliderId}-value`).style.opacity = '1';
    },
    toggleTooltip() {
      const { cancelTimers, sliderId } = this;
      cancelTimers();
      document.getElementById(`${sliderId}-value`).style.opacity = '1';
      this.tooltipTimer = window.setTimeout(() => {
        document.getElementById(`${sliderId}-value`).style.opacity = '0';
      }, 1000);
    },
    handleSliderOnInput() {
      this.deSelectPreset();
      this.toggleTooltip();
    },
  },
};
</script>

<template>
  <div class="range-slider-wrap" @mouseover="showTooltip()" @mouseout="hideTooltip()">
    <input
      v-model="currentValue"
      :id="sliderId"
      class="predictor-range-slider"
      type="range"
      min="0"
      max="100"
      @input="handleSliderOnInput"
    >
    <output :id="`${sliderId}-value`">
      <i></i>
      <span>{{ currentValue }}%</span>
    </output>
    <v-style>{{ rangeTrackStyle }}</v-style>
  </div>
</template>
